import React from 'react';
import Icon from '@sparebankenvest/ikoner/dist/icons/icon-info-circle.svg';

export default (props) => <Icon {...props} />;
